import { z } from 'zod';
import { layoutSchema } from './entities/layout';

/**
 * The extraction container's contract (`apps/script-extract`, docs/script-intake.md): `POST /extract` with the PDF
 * bytes as the body. `firstPagesText` is pages 1 to 5 and `sampleText` pages 1 to 75.
 */
export const extractedScriptSchema = z.object({
  pageCount: z.number().int().nonnegative(),
  wordCount: z.number().int().nonnegative(),
  firstPagesText: z.string(),
  sampleText: z.string(),
});
export type ExtractedScript = z.infer<typeof extractedScriptSchema>;

/** Why the container could not use a file: not a PDF, no text layer (a scan), or it needs a password. */
export const EXTRACT_ERRORS = ['not_a_pdf', 'no_text', 'encrypted'] as const;
export const extractErrorSchema = z.object({ error: z.enum(EXTRACT_ERRORS) });
export type ExtractError = z.infer<typeof extractErrorSchema>;

export const extractResponseSchema = z.union([extractedScriptSchema, extractErrorSchema]);
export type ExtractResponse = z.infer<typeof extractResponseSchema>;

/**
 * `POST /layout`: the same bytes, answered with `script.txt` (one line per laid-out line, page markers, indentation,
 * style tags) and `layout.json` (docs/script-entities.md). Refused with the same codes as `/extract`.
 */
export const layoutResponseSchema = z.object({ text: z.string(), layout: layoutSchema });
export type LayoutResponse = z.infer<typeof layoutResponseSchema>;
export const layoutResultSchema = z.union([layoutResponseSchema, extractErrorSchema]);
export type LayoutResult = z.infer<typeof layoutResultSchema>;
